import { render, staticRenderFns } from "./W2ChannelDetail.vue?vue&type=template&id=2434eea7&scoped=true"
import script from "./W2ChannelDetail.vue?vue&type=script&lang=js"
export * from "./W2ChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./W2ChannelDetail.vue?vue&type=style&index=0&id=2434eea7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434eea7",
  null
  
)

export default component.exports